module.exports = __webpack_public_path__ + "img/red.3d28a249.svg";